import { MagnitudesModel } from '@/store/catalogos/magnitudes';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoMagnitudesService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'variables';

  constructor(private http: HttpClient) { }

  getAll(): Observable<MagnitudesModel[]> {
    return this.http.get<MagnitudesModel[]>(this.baseUrl, httpOptions);
  }

  create(magnitud: MagnitudesModel): Observable<MagnitudesModel> {
    return this.http.post<MagnitudesModel>(this.baseUrl, magnitud, httpOptions);
  }

  update(magnitud: MagnitudesModel): Observable<MagnitudesModel> {
    return this.http.put<MagnitudesModel>(`${this.baseUrl}/${magnitud.idVariable}`, magnitud, httpOptions);
  }


}
